import { InternalMetrics } from '@arpeggi/shared'
import { useAuth } from '../../hooks/useAuth'

export const useInternalMetricsAPI = () => {
  const { authenticatedGet } = useAuth()

  const getInternalMetrics = async () => {
    const { data } = await authenticatedGet<InternalMetrics>('/api/v2/metrics')

    return data
  }

  return { getInternalMetrics }
}
